import { cn } from '@/utils/cn';
import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  message?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  message = 'Aucune donnee',
  description,
  icon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-center', className)}>
      <div className="mb-4 text-neutral-400 dark:text-neutral-600">
        {icon || <Inbox className="h-12 w-12" />}
      </div>
      <p className="text-sm font-medium text-neutral-600 dark:text-neutral-400">{message}</p>
      {description && <p className="mt-1 text-xs text-neutral-500">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
